export enum PatientContactType {
  'Home' = 0,
  'Mobile' = 1,
  'Work' = 2,
}
